import { gql, type TypedDocumentNode } from '@apollo/client';
import { FRONTEND_ASSET_HOST } from '@sorare/core/src/constants/assets';
import { withFragments } from '@sorare/core/src/lib/gql';

import {
  EditionVariant,
  Skin,
} from '@sorare/core/src/__generated__/globalTypes';
import type { getSkinEditionVideoSources_skinEdition } from './__generated__/lib.graphql';

export const getVideoSources = ({
  isNew,
  dropRank,
  isIceBreaker,
}: {
  isNew: boolean;
  dropRank: Nullable<number>;
  isIceBreaker: boolean;
}) => {
  const cardTier = typeof dropRank === 'number' ? dropRank : Infinity;

  if (isIceBreaker) {
    return {
      av1: `${FRONTEND_ASSET_HOST}/animations/packs/icebreaker_av1.mp4`,
      hevc: `${FRONTEND_ASSET_HOST}/animations/packs/icebreaker_hevc.mp4`,
    };
  }

  if (!isNew && cardTier > 3) {
    return null;
  }
  const cardTierString = cardTier > 3 ? '' : `T${cardTier}_`;
  const newString = isNew ? 'new_' : '';

  return {
    av1: `${FRONTEND_ASSET_HOST}/animations/packs/${cardTierString}${newString}av1.mp4`,
    hevc: `${FRONTEND_ASSET_HOST}/animations/packs/${cardTierString}${newString}hevc.mp4`,
  };
};

export const getSkinEditionVideoSources = withFragments(
  (skinEdition: getSkinEditionVideoSources_skinEdition) => {
    const { skin, variant } = skinEdition;
    if (skin === Skin.FULL_ART) {
      return 'fullArt' as const;
    }
    if (skin === Skin.HOLO) {
      return 'holo' as const;
    }
    if (skin === Skin.SHINY && variant === EditionVariant.VARIANT_1) {
      return 'jerseyNumber' as const;
    }
    if (skin === Skin.SHINY && variant === EditionVariant.VARIANT_2) {
      return 'meteorStriker' as const;
    }
    return null;
  },
  {
    skinEdition: gql`
      fragment getSkinEditionVideoSources_skinEdition on SkinEdition {
        skin
        variant
      }
    ` as TypedDocumentNode<getSkinEditionVideoSources_skinEdition>,
  }
);
